import React from 'react';
import PropTypes from 'prop-types';
import { ButtonContainer, ConnectButton } from './Styles';

const ConnectDisconnect = ({
  connected,
  onOpenConnection,
  onCloseConnection,
}) => (
  <>
    {!connected && (
    <ButtonContainer>
      <ConnectButton onClick={onOpenConnection}>
        <i className="fa fa-bolt fa-2" aria-hidden="true" />
        Connect
      </ConnectButton>
    </ButtonContainer>
    )}
  </>
);


ConnectDisconnect.propTypes = {
  connected: PropTypes.bool,
  onOpenConnection: PropTypes.func.isRequired,
  onCloseConnection: PropTypes.func.isRequired,
};


ConnectDisconnect.defaultProps = {
  connected: false,
};

export default ConnectDisconnect;
